var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.243 1.757L9.3 2.7A4.667 4.667 0 1010.667 6H12a6 6 0 11-1.757-4.243z",
    fill: "#7687AD"
  })));
}
export default __webpack_public_path__ + "static/_/shared/assets/svg/live-game/app/tag-loader.svg";
export { SvgTagLoader as ReactComponent };